import React from 'react';
import "./Loader.css"

export default function Loader() {
    return(
        <>
            <div class="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
        </>
    )
}